import script from "./VAppError.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAppError.vue?vue&type=script&setup=true&lang=ts"

import "./VAppError.vue?vue&type=style&index=0&id=8f744100&lang=scss"

const __exports__ = script;

export default __exports__